import { render, staticRenderFns } from "./managementDetail.vue?vue&type=template&id=f3736070&scoped=true&"
import script from "./managementDetail.vue?vue&type=script&lang=js&"
export * from "./managementDetail.vue?vue&type=script&lang=js&"
import style0 from "./managementDetail.vue?vue&type=style&index=0&id=f3736070&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3736070",
  null
  
)

export default component.exports